import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../Card';
import { Tier1HoldingRow } from '../../types/tier1Portfolio';
import EtfSymbolLink from './EtfSymbolLink';
import { fmtUsd } from './format';

interface Props {
  registeredHoldings: Tier1HoldingRow[];
  unmappedHoldings: Tier1HoldingRow[];
  planSymbolsNotHeld: string[];
}

const Tier1HoldingsTruthPanel: React.FC<Props> = ({
  registeredHoldings,
  unmappedHoldings,
  planSymbolsNotHeld,
}) => {
  const verified = registeredHoldings.filter((h) => h.tagVerified);

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Registered holdings</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="mb-2 text-xs text-gray-500">
            Count toward Tier 1 budget (registry tag + Schwab reconcile).
          </p>
          {verified.length === 0 ? (
            <p className="text-sm text-gray-600">No deployed registry slots yet.</p>
          ) : (
            <ul className="space-y-1 text-sm">
              {verified.map((h) => (
                <li key={`${h.symbol}-${h.sleeveKey}`} className="flex justify-between gap-4">
                  <span>
                    <EtfSymbolLink symbol={h.symbol} sleeveKey={h.sleeveKey ?? undefined} />
                    {h.sleeveKey ? ` · ${h.sleeveKey}` : ''}
                  </span>
                  <span className="text-gray-600">{fmtUsd(h.marketValue)}</span>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>

      {unmappedHoldings.length > 0 ? (
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Unmapped Schwab equity</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="mb-2 text-xs text-gray-500">
              Not linked to a Tier 1 registry slot — does not count toward Tier 1 deployable
              envelope.
            </p>
            <ul className="space-y-1 text-sm text-gray-700">
              {unmappedHoldings.map((h) => (
                <li key={h.symbol} className="flex justify-between gap-4">
                  <span>
                    <EtfSymbolLink symbol={h.symbol} />
                  </span>
                  <span>{fmtUsd(h.marketValue)}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      ) : null}

      {planSymbolsNotHeld.length > 0 ? (
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Plan gaps</CardTitle>
          </CardHeader>
          <CardContent className="text-sm text-gray-600">
            IPS ETFs not yet held at Schwab:{' '}
            {planSymbolsNotHeld.map((sym, i) => (
              <span key={sym}>
                {i > 0 ? ', ' : null}
                <EtfSymbolLink symbol={sym} />
              </span>
            ))}
          </CardContent>
        </Card>
      ) : null}
    </div>
  );
};

export default Tier1HoldingsTruthPanel;
